import {doUnblockPage} from '@assets/js/input/load_page_helper';
import {handleError} from '@assets/middlewares/errorHandler';
import Notify from './notify';

const notify = new Notify();

export var delay = (function () {
    let timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
}());

export var throttle = (func, limit) => {
    let inThrottle;
    return function () {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(() => { return inThrottle = false; }, limit);
        }
    };
};

export function simpleRequest(url, data, callback, type, options) {
    if (options === undefined) {
        options = {};
    }
    if ($.isFunction(data)) {
        type = callback;
        callback = data;
        data = {};
    }
    type = type || 'get';
    const defaultOptions = {
        type,
        url,
        data,
        dataType: 'json',
        success(response) {
            if (callback) {
                callback.call(self, response);
            }
        },
        error(e) {
            handleError(e);
        },
        complete() {
            doUnblockPage();
        },
    };
    for (const key in options) {
        defaultOptions[key] = options[key];
    }
    $.ajax(defaultOptions);
}

export function simpleRequestPromise(url, data = {}, type = 'get') {
    return new Promise((resolve) => {
        return ajaxPromise(url, data, type)
            .then((response) => {
                if (typeof response.success !== 'undefined' && response.success == false) {
                    if (response.message) {
                        notify.showMessage('onError', response.message);
                    } else if (response.errors) {
                        notify.showMessage('onError', response.errors);
                    } else {
                        notify.showMessage(
                            'onError',
                            'Произошла ошибка на сервере. Пожалуйста, обратитесь к администратору.',
                        );
                    }
                } else {
                    resolve(response);
                }
            })
            .catch((e) => {
                handleError(e);
            })
            .finally(() => {
                doUnblockPage();
            });
    });
}

export function ajaxPromise(url, data = {}, type = 'get') {
    return new Promise((resolve, reject) => {
        $.ajax({
            type,
            url,
            dataType: 'json',
            data,
            success: (response) => {
                resolve(response);
            },
            error: (err) => {
                reject(err);
            },
        });
    });
}

export function declension(num, expressions) {
    let result;
    let count;
    count = num % 100;
    if (count >= 5 && count <= 20) {
        result = expressions['2'];
    } else {
        count %= 10;
        if (count == 1) {
            result = expressions['0'];
        } else if (count >= 2 && count <= 4) {
            result = expressions['1'];
        } else {
            result = expressions['2'];
        }
    }
    return result;
}

export function updateURIparameter(param, paramVal) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set(`${param}`, `${paramVal}`);
    return `${window.location.origin + window.location.pathname}?${urlParams.toString()}`;
}

export function deleteURIparameter(param) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete(param);
    let params = urlParams.toString();
    if (params) {
        params = `?${params}`;
    }
    return window.location.origin + window.location.pathname + params;
}

export function isURIparameterExist(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(param);
}

export function getURIparameterValue(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}
